export type AlcanceComunicacion = 'todos' | 'prestadores' | 'comercios' | 'clientes' | 'socios' | 'usuario';

export const ALCANCE_LABELS: Record<string, string> = {
    todos: 'Todos',
    prestadores: 'Prestadores',
    comercios: 'Comercios',
    clientes: 'Clientes',
    socios: 'Socios',
    usuario: 'Usuario específico',
};

export type AppDestino = 'cardio' | 'libresalud' | 'ambas';

export const APP_DESTINO_LABELS: Record<string, string> = {
    cardio: 'Cardio',
    libresalud: 'Libre Salud',
    ambas: 'Ambas',
};

export interface Comunicacion{
    id?: number;
    id_usuario_admin?: string;
    x_titulo?: string;
    x_descripcion?: string;
    x_img?: string | null;
    x_alcance?: AlcanceComunicacion;
    x_app?: AppDestino;
    id_usuario_destino?: string | null;
    x_admin_email?: string;
    x_destino_email?: string;
    b_envia_email?: boolean;
    n_destinatarios?: number;
    n_enviados_ok?: number;
    n_leidos?: number;
    d_fecha?: Date;
}
